// frontend_react/src/components/restaurant/ItemList.jsx

import React, { useEffect, useMemo, useState } from "react";

function ItemList({ ajouterAuPanier, productMap = {}, allCategories = [] }) {
  const [recherche, setRecherche] = useState("");
  const [categorieId, setCategorieId] = useState(allCategories[0]?.uuid || null);

  useEffect(() => {
    if (!allCategories.length) {
      setCategorieId(null);
      return;
    }

    const stillExists = allCategories.some((cat) => cat.uuid === categorieId);

    if (!stillExists) {
      setCategorieId(allCategories[0].uuid);
    }
  }, [allCategories, categorieId]);

  const allProducts = useMemo(() => Object.values(productMap || {}), [productMap]);

  const visibles = allProducts.filter((product) => {
    const name = String(product?.name || "").toLowerCase();
    const search = recherche.toLowerCase();

    const matchSearch = name.includes(search);
    const matchCat = categorieId ? product?.category_id === categorieId : true;

    return matchSearch && matchCat;
  });

  return (
    <>
      <div className="categories">
        {allCategories.map((cat) => (
          <button
            key={cat.uuid}
            className={`category ${categorieId === cat.uuid ? "category--active" : ""}`}
            style={{ backgroundColor: cat.color ? `${cat.color}33` : undefined }}
            onClick={() => setCategorieId(cat.uuid)}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className="products-area">
        <input
          className="search-bar"
          value={recherche}
          onChange={(e) => setRecherche(e.target.value)}
          placeholder="Rechercher un produit..."
        />

        <div className="product-grid">
          {visibles.map((product) => {
            const price = Number(product?.price || 0) / 100;

            return (
              <button
                key={product.uuid}
                className="product-card"
                onClick={() => ajouterAuPanier(product)}
              >
                <span className="product-card__name">{product.name}</span>
                <span className="product-card__price">{price.toFixed(2)} €</span>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default ItemList;